import { parse } from 'qs';
import { set as setCookie, get as getCookie, remove as removeCookie } from 'js-cookie';

import appConfig from '../appConfig';

const REFERRER_CODE_COOKIE_KEY = `${appConfig.brand.name.replace(/\s/g, '').toLowerCase()}_referrer_code`;
const REFERRER_CODE_QUERY_KEY = 'Referrer';
const REFERRER_CODE_DAYS_VALIDITY = 7;

export const storeReferrerCode = () => {
	const urlParams = parse(window.location.search, {
		ignoreQueryPrefix: true,
	});

	const referrerCode = urlParams[REFERRER_CODE_QUERY_KEY] as string;

	if (referrerCode) {
		setCookie(REFERRER_CODE_COOKIE_KEY, referrerCode, {
			expires: REFERRER_CODE_DAYS_VALIDITY,
		});
	}
};

export const removeReferrerCode = () => {
	removeCookie(REFERRER_CODE_COOKIE_KEY);
};

export const getReferrerCode = () => {
	return getCookie(REFERRER_CODE_COOKIE_KEY);
};
